import axios from '../utils/axios';

const BASE = '/company-whatsapp-settings';

const whatsappSettingsService = {
  get: async () => {
    const response = await axios.get(BASE);
    return response.data;
  },

  save: async (payload) => {
    const response = await axios.put(BASE, payload);
    return response.data;
  },

  sendTestMessage: async ({ phone, message }) => {
    const response = await axios.post(`${BASE}/test-message`, {
      phone,
      message: message || undefined,
    });
    return response.data;
  },
};

export default whatsappSettingsService;
